import dayjs from 'dayjs';
import 'dayjs/locale/ru';

export function formatDate(date: string | unknown, periodType: string) {
  if (typeof date !== 'string') return null;

  const djs = dayjs(date).locale('ru');

  switch (periodType) {
    case 'day':
      return djs.format('DD.MM.YYYY');
    case 'month':
      return djs.format('YYYY MMM');
    default:
      return djs.format(periodType);
  }
}

export function formatMoney(value: number | string | null, n: number = 2, scale = true) {
  if (value === null || +value < Number.MIN_VALUE) return null;

  // K is 1/10 to display values like 0.0015 mBTC as 1.5 nBTC
  if (scale && +value < (1 / 100_000)) return (+value * 1_000_000).toFixed(n);
  if (scale && +value < (1 / 100)) return (+value * 1_000).toFixed(n);

  const m = 10 ** n;

  return (Math.floor(+value * m) / m).toFixed(n);
}

export function formatCurrency(value: number | string | null, currency: string) {
  if (!value) return currency;

  if (+value < (1 / 100_000) && currency !== 'USD') return 'μ' + currency;

  if (+value < (1 / 100) && currency !== 'USD') return 'm' + currency;

  return currency;
}

export function inflect(v: number, one: string, some: string, many: string = '') {
  const ten = [many, one, some, some, some, many, many, many, many, many];
  const rem = v % 100;
  return rem >= 11 && rem <= 14 ? many : ten[v % 10];
}

export function formatBytes(bytes: number, decimals = 2) {
  if (!+bytes) return '0 Bytes';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}
